import Vue from 'vue'
import moment from 'moment'
import i18n from '@/plugins/i18n'
import { getNormalizedLocale } from '@/helpers/i18n.helpers'
import { utcDateToUtcFormat } from '@/helpers/date.helpers'

const defaultDateFormat = 'dddd, LL'

function formatDate (date, format, utc = true) {
  if (!date) return ''
	if (utc) {
		date = utcDateToUtcFormat(date)
	}
  const dateWithLocale = moment(date).locale(getNormalizedLocale())
  return `${dateWithLocale.format(format)}${format === defaultDateFormat ? (` ${i18n.t('at-time')} ${dateWithLocale.format('LT')}`) : ''}`
}

Vue.filter('beautifyDate', (date, format = defaultDateFormat, utc = true) => {
  return formatDate(date, format, utc)
})

Vue.filter('beautifySimpleDate', (date, utc = true) => {
  return formatDate(date, 'DD/MM/YYYY', utc)
})

Vue.filter('beautifySimpleDateTime', (date, utc = true) => {
  return formatDate(date, 'DD/MM/YYYY HH:mm:ss', utc)
})

export default Vue.options.filters



// WEBPACK FOOTER //
// ./src/plugins/filters.js